//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useCallback, useEffect, useContext } from "react";
import { useLocation, useHistory } from "react-router-dom";

// custom pages
import { styles } from "./styles";
// import { ImportDataHeader } from "./Headers/headers";
import Context from "context/context";

// material-ui
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import Button from "@material-ui/core/Button";
import { useTranslation } from 'react-i18next';
import { CSVLink } from 'react-csv';
import { exportHeaders } from "./export";
import * as moment from "moment";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";

export default function ImportStatus() {
  const { state, dispatch } = useContext(Context);
  const location = useLocation();
  const history = useHistory();
  const classes = styles();
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [exportData, setExportData] = useState([]);
  const { t, i18n } = useTranslation()
  
  let ImportDataHeader = [];
  let ImportDataHeaderExport = [];

 
  
  let data = {};
  if (location.state?.type) {
    
    data = location.state;
  }
 
  let obj = {};

if (location.state?.obj) {
  obj = location.state?.obj;
    ImportDataHeader = obj?.ImportDataHeader;
    ImportDataHeaderExport=obj?.headers
  } 

  if(!location.state){
    history.goBack();
  }
//   console.log
let selectedColumns = ImportDataHeaderExport.map((header) => header.label);

  const [states, setstates] = useState({
    columns: [],
    currentYear: "",
    dialog: false,
    data: [],
    selectedFields: [],
    loading: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  useEffect(() => {
    let data = [];
    ImportDataHeaderExport.map((header, i) => {
      if (selectedColumns?.includes(header.label)) {
        data = [...data, header.key];
        return;
      }
    });
    setCount(obj?.invalidData?.length );
    setStates({ selectedFields: data });
  }, []);

  let combinedData=[]
  if(obj?.data?.invalidData){
   combinedData = [...combinedData,...obj?.data?.invalidData];
  }
  if(obj?.data?.successData){
    combinedData = [...combinedData,...obj?.data?.successData.map(item => ({
      ...item,
      reason: item.reason ? item.reason : "-"
    }))];

  }
  
 
  

const handleExport = async () => {
 
   dispatch({ type: "SET_LOADING", payload: true });
        setExportData(combinedData);
        dispatch({ type: "SET_LOADING", payload: false });
       return true;
     
    }

  

   return (
    <div>
     <Button className={classes.backBtn} onClick={() => history.goBack()}>
        Back
      </Button>
        {ImportDataHeaderExport.length>0 ? (
        <>
         <CSVLink
            id="csv"
            data={exportData.map(item => ({
              ...item,
              reason: item.reason ? item.reason : "-"
            }))}
            headers={ImportDataHeaderExport}
            filename={
              `invalid-data` +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A") +
              ".csv"
            }
            className={classes.CSVlink}
          />
             <button
            // disabled={isLoading}
            className={classes.exportBtn1}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            {t('Export')}
          </button>

            <Grid item xs={12} className={classes.contentGrid}>
            <div className={classes.content2}>
                Number of uploaded records : {obj?.uploadedCount} 
                <br />
                Number of successful records : {obj?.successCount}
              <br />
                Number of failed records : {obj?.invalidCount}
            </div>
          </Grid>
        <div>Records Status :</div>
        <TableContainer className={classes.tableContainer}>
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={"medium"}
          aria-label="enhanced table"
        >
          <TableHead
            style={{
              background: "#EDEDED",
              boxShadow:
                "rgb(112 112 112 / 60%) 0px 1.5px 4px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 1px 0px, rgb(255 255 255) 0px -4px 0px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 0px 0px",
            }}
          >
            <TableRow>
              {selectedColumns?.map((h, i) => (
                <TableCell key={i} className={classes.tableHeading}>
                  {h}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {combinedData.slice((offset - 1) * 10, offset * 10).map((p, i) => (
              
                <TableRow role="checkbox" tabIndex={-1} key={i}>
                  {states.selectedFields.map((s) => (
                    <TableCell
                      key={p?.[s]}
                      align="left"
                      className={classes.rowCell}
                    >
                      {p?.[s]}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        className={classes.pagination}
        variant="outlined"
        shape="rounded"
        count={
          (count / 10) % 1 == 0
            ? Math.floor(count / 10)
            : Math.floor(count / 10 + 1)
        }
        page={offset}
        siblingCount={1}
        onChange={(event, value) => {
          handlePagination(value);
        }}
      />
      </>
        )
        :
        <> 
        
        <Grid item xs={12} className={classes.contentGrid}>
        <div className={classes.content1}>
          <CheckCircleOutlineIcon className={classes.checkIcon} />
          &nbsp; {t('Congratulations!')}
        </div>
        <div className={classes.content2}>
          <pre >{data?.data?.successCount +' '+ data?.type }</pre>
        </div>
        
      </Grid>
        </>
    }
    </div>
  );
}
